<template>
    <a-modal v-model="visible" title="编辑区域信息" :width="600" centered :confirmLoading="loading" @ok="doValidate()">
        <a-form-model ref="formRef" :model="formData">
            <a-row :gutter="10">
                <a-col :span="7">
                    <a-form-model-item label="区域图片" prop="image">
                        <thumb v-model="formData.image" :size="1" :width="140" :height="140" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="16">
                    <a-form-model-item label="区域名称" label-position="top" prop="name"
                        :rules="{ required: true, message: '请输入区域名称' }">
                        <a-input v-model="formData.name" placeholder="请输入区域名称"></a-input>
                    </a-form-model-item></a-col>
                <a-col :span="4">
                    <a-form-model-item label="排序" label-position="top" prop="sort"
                        :rules="{ required: true, message: '请输入排序值' }">
                        <a-input-number v-model="formData.sort" placeholder="排序值"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="所属单位" label-position="top" prop="organId"
                        :rules="{ required: true, message: '请选择所属单位' }">
                        <choose-organ v-model="formData.organId"></choose-organ>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-space direction="vertical">
                <span>1.适配小程序首页图片,排序值最大的一张图片为第一张图；</span>
                <span>2.第一张尺寸：270 x 290,其他图片：180 x 140</span>
            </a-space>

        </a-form-model>
    </a-modal>
</template>

<script>
import request from '@/config/request';
import utils from '@/common/utils';
import apiUtils from '@/common/apiUtil';
import thumb from '@/components/thumb.vue';
export default {
    components: { thumb },
    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                areaId: '',
                name: '',
                sort: 0,
                thumb: '',
                organId: apiUtils.getOrganId()
            }
        }
    },
    methods: {
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    console.log(this.formData)
                    return;
                }
                this.loading = true;
                request.post('/platform/store/area/save', this.formData).then(ret => {
                    utils.success('操作成功！').then(() => {
                        this.visible = false;
                        this.$emit('success');
                    });
                }).finally(() => {
                    this.loading = false;
                })
            })
        },
        show(json) {
            this.formData.areaId = '';
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
                if (json) {
                    this.formData = JSON.parse(JSON.stringify(json))
                }
            })
        }
    }
}
</script>

<style></style>